import request from '@/utils/request.js';

// 发送验证码
export function sendSmsCode(data) {
  return request({
    url: '/Sms/sendSmsCode',
    method: 'get',
    params: data,
  });
}

// 获取图形验证码
export function getCaptchaCode() {
  return request({
    url: '/index/verify',
    method: 'get',
    apiModule:'adminapi'
  });
}

// 获取文件导出历史
export function exportTaskList(data) {
  return request({
    url: '/exportTask/exportTaskList',
    method: 'post',
    data: data,
  });
}

// 获取资金模块文件导出历史
export function exportFundTaskList(data) {
  return request({
    url: '/exportTask/exportTaskList',
    apiModule: 'fund',
    method: 'get',
    params: data,
  });
}

// 获取国家列表
export function getCountry(data) {
  return request({
    url: '/Supplier/getCountries',
    method: 'get',
    params: data,
  });
}
// 获取省列表 
export function getProvinces(data) {
  return request({
    url: '/supplier/getStates',
    method: 'get',
    params: data,
  });
}
// 获取市列表
export function getCity(data) {
  return request({
    url: '/supplier/getCity',
    method: 'get',
    params: data,
  });
}
// 获取区列表
export function getDistrict(data) {
  return request({
    url: '/supplier/getRegions',
    method: 'get',
    params: data,
  });
}
